import React from 'react';
import { CheckCircleIcon, DownloadIcon, MailIcon } from 'lucide-react';
const ConfirmationPage = () => {
  return <div className="min-h-screen bg-slate-50 py-12" data-id="element-9">
      <div className="container mx-auto px-4 md:px-6 max-w-3xl" data-id="element-10">
        <div className="bg-white rounded-lg shadow-md p-8 md:p-12 text-center" data-id="element-11">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-12">
            <CheckCircleIcon size={40} className="text-green-600" data-id="element-13" />
          </div>
          <h1 className="text-3xl font-bold text-navy-900 mb-4" data-id="element-14">Thank You!</h1>
          <p className="text-lg text-slate-700 mb-8" data-id="element-15">
            Your Will and Power of Attorney intake form has been successfully
            submitted.
          </p>
          <div className="bg-slate-50 p-6 rounded-lg mb-8 text-left" data-id="element-16">
            <h2 className="text-xl font-semibold text-navy-900 mb-4" data-id="element-17">
              What Happens Next?
            </h2>
            <ul className="space-y-3" data-id="element-18">
              <li className="flex" data-id="element-19">
                <div className="flex-shrink-0 h-6 w-6 bg-navy-100 rounded-full flex items-center justify-center mr-3 mt-0.5" data-id="element-20">
                  <span className="text-navy-700 font-medium text-sm" data-id="element-21">1</span>
                </div>
                <p className="text-slate-700" data-id="element-22">
                  Our legal team will review your information within 1-2
                  business days.
                </p>
              </li>
              <li className="flex" data-id="element-23">
                <div className="flex-shrink-0 h-6 w-6 bg-navy-100 rounded-full flex items-center justify-center mr-3 mt-0.5" data-id="element-24">
                  <span className="text-navy-700 font-medium text-sm" data-id="element-25">2</span>
                </div>
                <p className="text-slate-700" data-id="element-26">
                  You'll receive an email confirmation with a copy of your
                  responses.
                </p>
              </li>
              <li className="flex" data-id="element-27">
                <div className="flex-shrink-0 h-6 w-6 bg-navy-100 rounded-full flex items-center justify-center mr-3 mt-0.5" data-id="element-28">
                  <span className="text-navy-700 font-medium text-sm" data-id="element-29">3</span>
                </div>
                <p className="text-slate-700" data-id="element-30">
                  A lawyer will contact you to schedule a consultation or
                  request additional information if needed.
                </p>
              </li>
            </ul>
          </div>
          <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4" data-id="element-31">
            <button className="flex items-center justify-center px-6 py-3 bg-navy-700 text-white rounded-md hover:bg-navy-800 transition-colors" data-id="element-32">
              <DownloadIcon size={18} className="mr-2" data-id="element-33" />
              Download Copy of Responses
            </button>
            <button className="flex items-center justify-center px-6 py-3 border border-navy-700 text-navy-700 rounded-md hover:bg-navy-50 transition-colors" data-id="element-34">
              <MailIcon size={18} className="mr-2" data-id="element-35" />
              Email Me a Copy
            </button>
          </div>
          <p className="mt-8 text-sm text-slate-500" data-id="element-36">
            Reference #: WPA-{Math.floor(100000 + Math.random() * 900000)}
          </p>
        </div>
        <div className="mt-8 text-center" data-id="element-37">
          <p className="text-slate-600" data-id="element-38">
            If you have any questions, please contact us at:
          </p>
          <p className="font-medium text-navy-700 mt-1" data-id="element-39">
            (555) 123-4567 or support@lawfirmname.com
          </p>
        </div>
      </div>
    </div>;
};
export default ConfirmationPage;